import React from "react";
import { useI18n } from "../../context/I18nContext";
import { AlertTriangle } from "lucide-react";

export function RiskBanner() {
  const { t } = useI18n();
  return (
    <div className="bg-slate-900 text-slate-200 text-xs" data-testid="risk-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center gap-2">
        <AlertTriangle className="h-3.5 w-3.5 text-amber-400 shrink-0" />
        <span className="truncate">{t.warning.short}</span>
      </div>
    </div>
  );
}

export function RiskNote({ className = "" }) {
  const { t } = useI18n();
  return (
    <p className={`text-xs text-slate-500 ${className}`} data-testid="risk-note">
      {t.warning.short}
    </p>
  );
}
